// extracted by mini-css-extract-plugin
export default {"learningObjective":"learning-objective_learningObjective__eqmhp"};